import {
  Schema,
  ControlDataTypeKey
} from "@makeswift/controls";
const Types = {
  Backgrounds: "Backgrounds",
  Border: "Border",
  BorderRadius: "BorderRadius",
  Checkbox: "Checkbox",
  Date: "Date",
  ElementID: "ElementID",
  Font: "Font",
  GapX: "GapX",
  GapY: "GapY",
  Grid: "Grid",
  Image: "Image",
  Images: "Images",
  Link: "Link",
  Margin: "Margin",
  NavigationLinks: "NavigationLinks",
  Padding: "Padding",
  Number: "Number",
  Shadows: "Shadows",
  ResponsiveColor: "ResponsiveColor",
  ResponsiveIconRadioGroup: "ResponsiveIconRadioGroup",
  ResponsiveLength: "ResponsiveLength",
  ResponsiveNumber: "ResponsiveNumber",
  ResponsiveOpacity: "ResponsiveOpacity",
  ResponsiveSelect: "ResponsiveSelect",
  SocialLinks: "SocialLinks",
  TextArea: "TextArea",
  TextInput: "TextInput",
  Table: "Table",
  TableFormFields: "TableFormFields",
  TextStyle: "TextStyle",
  Width: "Width",
  Video: "Video"
};
export {
  ControlDataTypeKey,
  Schema,
  Types
};
//# sourceMappingURL=prop-controllers.js.map